import React from 'react';
import { Tab } from 'react-bootstrap';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { ProjectCard  } from './ProjectCard';
import textUtils from '../assests/img/textutilsimage.JPG';
import moviesapp from '../assests/img/moviesappimage.JPG';
import newsapp from '../assests/img/newsappimage.JPG';
import inotebook from '../assests/img/inotebokimage.JPG';
import bookstore from '../assests/img/bookstoreimage.JPG';
import finloans from '../assests/img/finloansimage.JPG';
import clock from '../assests/img/clockworldimage.JPG';
import TrackVisibility from 'react-on-screen';
import 'animate.css';


export const Projects = () => {

    const projects = [ 
        {
            title: "Finloans",
            description: "A website with main purpose to provide you instant loans in hard times.",
            imgUrl: finloans,
             gitUrl: "https://github.com/tosefsatti/finloans.git",
            liveUrl: "https://touseefzakria-finloans.netlify.app/"
        },
        {
            title: "TextUtils App",
            description: "A usefull textUtils app to manipulate your text, performs some actions on given text.",
            imgUrl: textUtils,
             gitUrl: "https://github.com/tosefsatti/TextUtils.git",
            liveUrl: "https://touseefzakria-textutilsapp.netlify.app/"
        },
        {
            title: "Movies House",
            description: "Movies House is React.js web app for latest movies to watch.",
            imgUrl: moviesapp,
             gitUrl: "https://github.com/tosefsatti/MoviesHouse.git",
            liveUrl: ""
        },
    ];

    const projects2 = [ 
      {
          title: "iNoteboook",
          description: "iNotebook is your notebook on the cloud for storing user's notes.",
          imgUrl: inotebook,
          gitUrl: "https://github.com/tosefsatti/inotebook.git",
          liveUrl: ""
      },
      {
          title: "BookStore",
          description: "Bookstore is full stack Mern project which allow users to read and purchase books",
          imgUrl: bookstore,
           gitUrl: "https://github.com/tosefsatti/bookstore.git",
          liveUrl: ""
      },
      {
        title: "News App",
        description: "NewsApp is developed for users who are fond of reading news articles",
        imgUrl: newsapp,
        gitUrl: "https://github.com/tosefsatti/newsapp.git",
        liveUrl: ""
    },
  ];

  const projects3 = [ 
    {
        title: "Clock World",
        description: "Digital clock shows time and a StopWatch with timer.",
        imgUrl: clock,
        gitUrl: "https://github.com/tosefsatti/clockworld.git",
        liveUrl: "https://touseefzakria-clockworld.netlify.app/"
    },
    {
        title: "BookStore",
        description: "Bookstore is full stack Mern project which allow users to read and purchase books",
        imgUrl: bookstore,
         gitUrl: "https://github.com/tosefsatti/bookstore.git",
        liveUrl: ""
    },
    {
        title: "Finloans",
        description: "A website with main purpose to provide you instant loans in hard times.",
        imgUrl: finloans,
         gitUrl: "https://github.com/tosefsatti/finloans.git",
        liveUrl: "https://touseefzakria-finloans.netlify.app/"
    },
];

    return (
    <>
    <section className='project' id='projects'>
        <Container>
            <Row>
                <Col size={12}>
                
                <TrackVisibility>
            {
              ({ isVisible }) =>
            
            <div className={isVisible ? "animate__animated animate__bounce" : ""}>
                <h2>Projects</h2>
                <p className=''>My portfolio showcases a range of React.js projects, including a dynamic news app, responsive navigation components, and full-stack applications with Express.js and MongoDB. Each project highlights my ability to create scalable, user-friendly solutions with a focus on clean code and modern design principles.</p>
                </div>}
                </TrackVisibility>
                <Tab.Container id='projects-tab' defaultActiveKey="first">
                <Nav variant="pills" className='nav-pills mb-5 justify-content-center align-items-center' id='pills-tab'>
                    <Nav.Item>
                      <Nav.Link eventKey='first'>Tab one</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Tab two</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">
                        Tab three
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="first">
                        <Row>
                            {
                                projects.map((project, index) =>{
                                    return (
                                      <ProjectCard
                                      key={index}
                                      {...project}
                                      />
                                    )
                                })
                            }
                        </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                        <Row>
                        {
                                projects2.map((project, index) =>{
                                    return (
                                      <ProjectCard
                                      key={index}
                                      {...project}
                                      />
                                    )
                                })
                            }
                        </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                        <Row>
                        {
                                projects3.map((project, index) =>{
                                    return (
                                      <ProjectCard
                                      key={index}
                                      {...project}
                                      />
                                    )
                                })
                            }
                        </Row>
                    </Tab.Pane>
                    
                  </Tab.Content>
                  </Tab.Container>
                </Col>
            </Row>
        </Container>
       
    </section>
    </>
  );
}
